import { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import Lightbox from '@components/Common/Lightbox';
import './RecentProjects.css';

const architecturalImages = [
  { src: '/images/architectural/hospital-1.jpg', title: 'Hospital Design' },
  { src: '/images/architectural/hotel-1.jpg', title: 'Hotel Design' },
  {
    src: '/images/architectural/school-rmg-ladvi.jpg',
    title: 'RMG School at Ladvi',
  },
  { src: '/images/architectural/avalon-project.jpg', title: 'Avalon Project' },
  { src: '/images/architectural/bungalow-1.jpg', title: 'Bungalow Design' },
  { src: '/images/architectural/bungalow-2.jpg', title: 'Luxury Bungalow' },
  { src: '/images/architectural/daman-project.jpg', title: 'Daman Project' },
  { src: '/images/architectural/highrise-3.jpg', title: 'Highrise Building' },
  { src: '/images/architectural/highrise-5.jpg', title: 'Modern Highrise' },
  { src: '/images/architectural/delhi-lowrise.jpg', title: 'Delhi Lowrise' },
];

const RecentProjects = () => {
  const [lbOpen, setLbOpen] = useState(false);
  const [lbIndex, setLbIndex] = useState(0);
  const lightboxImages = architecturalImages.map((i) => i.src);

  return (
    <section className="recent-projects-section">
      <div className="container">
        <h2 className="section-title">Recent Projects</h2>
      </div>

      <div className="swiper-container-wrapper">
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          slidesPerView={3}
          spaceBetween={30}
          centeredSlides={true}
          loop={true}
          speed={900}
          autoplay={{
            delay: 1500,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
          }}
          navigation={true}
          breakpoints={{
            320: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            640: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          }}
          className="recent-projects-swiper"
        >
          {architecturalImages.map((img, idx) => (
            <SwiperSlide key={idx}>
              <div
                className="project-slide"
                onClick={() => {
                  setLbIndex(idx);
                  setLbOpen(true);
                }}
              >
                <img src={img.src} alt={img.title} className="project-image" />
                <div className="project-overlay">
                  <h3 className="project-title">{img.title}</h3>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {lbOpen && (
        <Lightbox
          images={lightboxImages}
          currentIndex={lbIndex}
          onClose={() => setLbOpen(false)}
        />
      )}
    </section>
  );
};

export default RecentProjects;
